import React from "react";

/**
 * Icons for the composer's action row, drawn on the same 24px grid and weight
 * as the drawer set so the two read as one family.
 */

type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
};

const Icon: React.FC<IconProps & { children: React.ReactNode }> = ({
  size = 14,
  children,
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    style={{ display: "block", flexShrink: 0 }}
    {...props}
  >
    {children}
  </svg>
);

export const MicIcon: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <rect x="9" y="2" width="6" height="12" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v4" />
  </Icon>
);

export const VoiceModeIcon: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M12 3a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M2.5 9v4M21.5 9v4" />
  </Icon>
);

export const SourcesIcon: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M10 3v4a2 2 0 0 1-2 2H4M14 21v-4a2 2 0 0 1 2-2h4M4 15h4a2 2 0 0 1 2 2v4M20 9h-4a2 2 0 0 1-2-2V3" />
  </Icon>
);
